import React from 'react';
import './CustomerStories.css'; // The stylesheet name stays the same

const CustomerStories = () => {
  return (
    <section className="c-stories-wrapper">
      <div className="c-stories-container">
        <h2 className="c-stories-title">Customer success stories</h2>
        
        <div className="c-stories-grid">
          
          {/* Card 1: Dave Singh */}
          <div className="c-stories-card c-stories-card--quote-layout">
            <div className="c-stories-card__img-container">
              <img src="https://sendbird.imgix.net/cms/1_2025-06-11-125740_lmxy.png?wm=webp" alt="Dave Singh" />
            </div>
            <div className="c-stories-card__content">
              <p className="c-stories-card__quote-text">
                “The AI agent platform from Sendbird stood out to us for its clean interface and user-friendly design. It’s clear they’re focused on building something that’s easy to engage with.”
              </p>
              <div className="c-stories-card__author">
                <span className="c-stories-card__author-name">Dave Singh</span>
                <span className="c-stories-card__author-title">Director of Product Management at Transcarent (formerly Accolade)</span>
              </div>
            </div>
          </div>

          {/* Card 2: Porter */}
          <a href="/customers" className="c-stories-card">
            <div className="c-stories-card__img-container c-stories-card__img-container--hover-zoom">
              <img src="https://sendbird.imgix.net/cms/3_2_2025-06-25-072011_ybfa.png?wm=webp" alt="Porter boxes" />
              <div className="c-stories-card__learn-more-overlay">
                <span>Learn more</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#F0F0F0"></path></svg>
              </div>
            </div>
            <div className="c-stories-card__content">
              <p className="c-stories-card__main-title">Porter improves open rates and saves significant SMS costs migrating to Sendbird Notifications</p>
            </div>
          </a>

          {/* Card 3: Redfin */}
          <a href="/customers" className="c-stories-card">
            <div className="c-stories-card__img-container c-stories-card__img-container--hover-zoom">
              <img src="https://sendbird.imgix.net/cms/3_2_2025-06-17-111121_ztqz.png?wm=webp" alt="House with Redfin sign" />
              <div className="c-stories-card__learn-more-overlay">
                <span>Learn more</span>
                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#F0F0F0"></path></svg>
              </div>
            </div>
            <div className="c-stories-card__content">
              <p className="c-stories-card__main-title">How Redfin's AI Assistant drove a 93% return rate in one week</p>
            </div>
          </a>

          {/* Card 4: Virgin Mobile */}
          <a href="/customers" className="c-stories-card c-stories-card--logo-quote">
            <div className="c-stories-card__header">
              <img src="https://sendbird.imgix.net/cms/Group-1000004106.svg" alt="Virgin Mobile Logo" className="c-stories-card__logo-img"/>
              <div className="c-stories-card__learn-more-link">
                <span>Learn more</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#0D0D0D"></path></svg>
              </div>
            </div>
            <div className="c-stories-card__content">
              <p className="c-stories-card__quote-text c-stories-card__quote-text--small">"Our customers are more engaged and consistently give us a CSAT score of 5/5."</p>
              <div className="c-stories-card__author">
                <span className="c-stories-card__author-name">Ozgur Gemici</span>
                <span className="c-stories-card__author-title">Sr. Product Manager at Virgin Mobile UAE</span>
              </div>
            </div>
          </a>
          
          {/* Card 5: AllAthlete */}
          <a href="/customers" className="c-stories-card">
            <div className="c-stories-card__img-container c-stories-card__img-container--hover-zoom">
              <img src="https://sendbird.imgix.net/cms/3_2_2025-06-17-111404_xzqu.png?wm=webp" alt="AllAthlete basketball players" />
              <div className="c-stories-card__learn-more-overlay">
                <span>Learn more</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#F0F0F0"></path></svg>
              </div>
            </div>
            <div className="c-stories-card__content">
              <p className="c-stories-card__main-title">AllAthlete boosts retention by 25% with Sendbird’s AI-driven experience</p>
            </div>
          </a>

          {/* Card 6: Hostelworld */}
          <a href="/customers" className="c-stories-card">
            <div className="c-stories-card__img-container c-stories-card__img-container--hover-zoom">
              <img src="https://sendbird.imgix.net/cms/hostelworld-customer.png?wm=webp" alt="Hostelworld customer" />
              <div className="c-stories-card__learn-more-overlay">
                <span>Learn more</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#F0F0F0"></path></svg>
              </div>
            </div>
            <div className="c-stories-card__content">
              <p className="c-stories-card__main-title">Hostelworld improves support efficiency with 40% fewer inquiries and higher customer satisfaction</p>
            </div>
          </a>

          {/* Card 7: Hinge */}
          <a href="/customers" className="c-stories-card">
            <div className="c-stories-card__img-container">
              <img src="https://sendbird.imgix.net/cms/03_hinge_2025-06-25-071626_kfot.jpg?wm=webp" alt="Hinge couple" />
              <div className="c-stories-card__learn-more-link c-stories-card__learn-more-link--dark">
                <span>Learn more</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="#0D0D0D"></path></svg>
              </div>
            </div>
            <div className="c-stories-card__content">
              <p className="c-stories-card__quote-text c-stories-card__quote-text--small">“We needed to find new digital ways for users to build meaningful connections and Sendbird's video API promises to do just that.”</p>
              <div className="c-stories-card__author">
                <span className="c-stories-card__author-name">Ben Celibicic</span>
                <span className="c-stories-card__author-title">CTO at Hinge</span>
              </div>
            </div>
          </a>

        </div>

        <div className="c-stories-footer">
          <a href="/customers" className="c-stories-footer__btn">
            See more stories
          </a>
        </div>
        
        {/* --- NEW CTA SECTION ADDED HERE --- */}
        <div className="c-stories-cta-section">
          <h4 className="c-stories-cta-section__title">
            Ready for <br />the next level?
          </h4>
          <a href="/customers" className="c-stories-cta-section__btn">
            Contact sales
          </a>
        </div>
        {/* --- END OF NEW CTA SECTION --- */}

      </div>
    </section>
  );
};

export default CustomerStories;